import { BackButton } from "../../components/features/BackButton";
import { paths } from "../../config/paths";
import { useNavigate } from "react-router-dom";
import { getAssetPath } from "../../lib/assetPath";
import { useTranslation } from "../../lib/i18n";

export const LooksGalleryHome = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full">
      <HeroSection
        title={t('looksGallery.beautyServices')}
        subtitle={t('looksGallery.yourGlamorousJourney')}
        backgroundImage="/looks-gallery/beauty-services/home.avif"
        path={paths.looksGallery.beautyServices.path}
      />
      <HeroSection
        title={t('looksGallery.galerieDesLooks')}
        subtitle={t('looksGallery.revealYourBeauty')}
        backgroundImage="/looks-gallery/looks-gallery/home.avif"
        backgroundPosition="center"
        path={paths.looksGallery.looksGallery.path}
        backButton={true}
      />
    </div>
  );
};

interface HeroSectionProps {
  title: string;
  subtitle: string;
  backgroundImage: string;
  backgroundPosition?: string;
  backButton?: boolean;
  path: string;
}

export const HeroSection = ({
  title,
  subtitle,
  backgroundImage,
  backgroundPosition = "right",
  backButton = false,
  path,
}: HeroSectionProps) => {
  const navigate = useNavigate();
  return (
    <div
      className="h-1/2 flex flex-col justify-end gap-6 p-6 cursor-pointer"
      style={{
        backgroundImage: `url("${getAssetPath(backgroundImage)}")`,
        backgroundSize: "cover",
        backgroundPosition,
      }}
      onClick={() => navigate(path)}
    >
      {backButton && (
        <div
          className="text-white"
          onClick={(e) => e.stopPropagation()}
        >
          <BackButton onClick={() => navigate(paths.app.path)} />
        </div>
      )}
      <div className="flex w-full p-4 flex-col rounded-[2px] bg-[rgba(5,5,5,0.2)] backdrop-blur-xl">
        <h1 className="text-white text-center font-bebas-kai text-[40px] font-normal">
          {title}
        </h1>
        <p className="text-white text-center font-garamond-italic text-[20px] italic font-normal">
          {subtitle}
        </p>
      </div>
    </div>
  );
};
